var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height",staticStyle:{"overflow-y":"auto"}},[_c('app-manage-detail-status-options',{attrs:{"user-info":_vm.userInfo,"workflow-data":_vm.workflowInfo,"local-data":_vm.localData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }